import axios from 'axios';
import { clearAuth, getAuthToken } from './utils/auth';

const api = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL || "https://server.pallimarket.bd/api",
  headers: { 'Content-Type': 'application/json' },
  timeout: 15000
});

api.interceptors.request.use((config) => {
  const token = getAuthToken();
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error?.response?.status === 401) {
      clearAuth();
    }
    return Promise.reject(error);
  }
);

export default api;
